import * as React from 'react';
import * as mobxReact from 'mobx-react';

import './paging.scss';

interface IProps {
    currentPage: number;
    totalRecords: number;
    pageSize: number;
}

const PagingRecordsCounts = mobxReact.observer((props: IProps) => {
  const currentPageOnTotalRecords = props.currentPage * props.pageSize;
  const startPageCount = (currentPageOnTotalRecords) - (props.pageSize - 1);
  const endPageCount = currentPageOnTotalRecords < props.totalRecords ? currentPageOnTotalRecords : props.totalRecords;
  return (
    <div className='records-count'>
      {!props.totalRecords ? null
        : <>
          <span>{`${startPageCount}-${endPageCount}`}</span> <b>of</b> <span>{props.totalRecords}</span>
        </>}
    </div>
    );
  });


export { PagingRecordsCounts };